import React, { useEffect } from 'react';
import { t, Trans } from '@lingui/macro';

import { H1, H3, Tag } from '@decisiv/ui-components';

import Helmet from '../../components/SEO/Helmet';
import useWhatsNew from '../../hooks/useWhatsNew';
import { formatIsoDay } from '../../utils/dates';
import {
  EmptyState,
  EntryCard,
  EntryDate,
  EntryDescription,
  EntryMeta,
  PageSection,
} from './style';

export default function WhatsNewPage() {
  const { entries, markAllSeen } = useWhatsNew();

  // Visiting the full page counts as "seeing" the updates, same as opening
  // the nav panel.
  useEffect(() => {
    markAllSeen();
  }, [markAllSeen]);

  return (
    <PageSection>
      <Helmet title={t`What's New`} />
      <H1>
        <Trans>What&apos;s New</Trans>
      </H1>
      {entries.length === 0 ? (
        <EmptyState>
          <Trans>No updates yet</Trans>
        </EmptyState>
      ) : (
        entries.map((entry) => (
          <EntryCard key={entry.id} id={entry.id}>
            <H3>{entry.title}</H3>
            <EntryMeta>
              <EntryDate>{formatIsoDay(entry.date)}</EntryDate>
              {entry.module && (
                <Tag text={entry.module} size="small" variant="outline" />
              )}
            </EntryMeta>
            <EntryDescription>{entry.description}</EntryDescription>
          </EntryCard>
        ))
      )}
    </PageSection>
  );
}
